/* eslint-disable i18next/no-literal-string -- a code-only module: every literal is an action or message code; it renders nothing */
// What a tab does about the C3 fence of ANOTHER tab (spec C3 "Peer tabs" and
// "Suspended or frozen tabs that missed a message"). Pure decisions; the app
// host (src/lib/offline/runtime.ts) applies them.
import { MSG } from './offline.codes'
import type { FenceMirror } from './offlineStore'

export type FenceAction =
  | { action: 'ok' }
  /** A transition is in progress: stop writers, refuse new ones. */
  | { action: 'suspend' }
  /** The owner changed: reload. */
  | { action: 'reload' }
  /** Same owner, no transition, a new fence epoch (a cancelled sign-out): adopt it and resume. */
  | { action: 'adopt'; epoch: number }

/**
 * On pageshow / visibilitychange / resume and inside every gate check: the
 * mirror against what this tab captured. A missing mirror changes nothing.
 */
export function fenceActionFor(captured: { ownerKey: string | null; fenceEpoch: number } | null, mirror: FenceMirror | null): FenceAction {
  if (!mirror || !captured) return { action: 'ok' }
  if (mirror.owner_key !== captured.ownerKey) return { action: 'reload' }
  if (mirror.transition_id) return { action: 'suspend' }
  if (mirror.fence_epoch !== captured.fenceEpoch) return { action: 'adopt', epoch: mirror.fence_epoch }
  return { action: 'ok' }
}

/** A BroadcastChannel("cb-account") message for the owner this tab shows. */
export function actionForMessage(currentOwner: string | null, msg: unknown): FenceAction {
  if (!msg || typeof msg !== 'object' || !currentOwner) return { action: 'ok' }
  const m = msg as { type?: unknown; owner?: unknown; fence_epoch?: unknown; from?: unknown; to?: unknown }
  if (m.type === MSG.ownerFence && m.owner === currentOwner) return { action: 'suspend' }
  if (m.type === MSG.ownerFenceCancelled && m.owner === currentOwner && typeof m.fence_epoch === 'number') {
    return { action: 'adopt', epoch: m.fence_epoch }
  }
  if (m.type === MSG.ownerChanged && m.from === currentOwner && m.from !== m.to) return { action: 'reload' }
  return { action: 'ok' }
}
